import { useEffect, useReducer } from 'react';
import { useGraphRendererApi } from './use-api';

/** Subscribe to selection and group edits without exposing engine collections. */
export const useGraphViewState = () => {
  const getApi = useGraphRendererApi();
  const api = getApi();
  const [, refresh] = useReducer((value: number) => value + 1, 0);
  useEffect(() => api?.views?.subscribe(refresh), [api]);
  return api;
};
